import { ActionIcon, Alert, AspectRatio, Badge, Button, Card, Center, Divider, Group, Image, Loader, Modal, Paper, Rating, SimpleGrid, Stack, Text, Textarea, TextInput, Title, Tooltip } from "@mantine/core";
import { useViewportSize } from "@mantine/hooks";
import { IconAlertCircle, IconAlertTriangle, IconBuildingStore, IconCheck, IconEye, IconHeartFilled, IconInfoCircle, IconMapPinFilled, IconPhoneFilled, IconSend, IconStarFilled, IconThumbUp } from "@tabler/icons-react";
import axios from "axios";
import { Link, navigate } from "gatsby";
import React, { forwardRef, useRef, useState } from 'react';
import 'slick-carousel/slick/slick-theme.css';
import 'slick-carousel/slick/slick.css';
import { Location, MyUser, Salon, SlideProps } from "../../global";
import { useLanguageNavigator, usePageContent } from "../../hooks";
import { useAppSelector as useSelector } from '../../hooks/ReduxHooks';
import { availableLanguages, baseApi } from "../api";
import MyNotifications from "./MyNotifications";

export const getUpcomingDays = () => {
    const days = [];
    const today = new Date();
    for (let i = 0; i < 7; i++) {
        const d = new Date(today);
        d.setDate(today.getDate() + i);
        const label = i === 0 ? "Today" : d.toLocaleDateString(undefined, { weekday: "long" });
        const value = d.toISOString().split("T")[0];
        days.push({ label, value });
    }
    return days;
};
export const bookNow = async (date: string, salon:Salon, userId:number, language:string, notes: string, type: string = "bk", offer?:number, offerItem?:number) => {
    console.log(date)
    console.log(salon)
    console.log(userId)
    console.log(offer)
    console.log(offerItem)
    // const { language } = useLanguageNavigator(availableLanguages);
    try {
        await initiatePayment(date, salon, userId, language, null, null, notes, type);
        // const response = await fetch(`${baseApi}/web/bookNow`, {
        //     method: "POST", headers: { "Content-Type": "application/json" },
        //     body: JSON.stringify({user_id: userId,salon_id: salon.id,offer_id: offer,offer_item_id:offerItem,booking_date: date,}),
        // });
        // const data = await response.json();
        // if (data.success) {
        //     MyNotifications({ text: language === "ar" ? "تم تأكيد الحجز بنجاح!" : "Booking confirmed successfully!",color: "green", icon: <IconCheck />,});
        // } else {
        //     MyNotifications({
        //         text: language === "ar" ? "خطأ: " + (data.message || "غير قادر على الحجز الآن"): "Error: " + (data.message || "Unable to book now"),
        //         color: "red", icon: <IconAlertTriangle />,
        //     });
        // }
    } catch (err) {
        console.error(err);
        MyNotifications({ text: language === "ar" ? "لقد حدث خطأ ما." : "Something went wrong.", color: "red", icon: <IconAlertTriangle />, });
    }
};
export const initiatePayment = async (
    date: string, salon: Salon, userId: number, language: string, offerId: number|null, 
    offerItemId: number|null, notes: string = "", type: string
): Promise<{ success: boolean; payment_url?: string; booking_id?: number; amount?: number }> => {
    try {
        const response = await fetch(`${baseApi}/web/payment/initiate`, {
            method: "POST",
            headers: { "Content-Type": "application/json" },
            body: JSON.stringify({
                user_id: userId,
                salon_id: salon.id,
                offer_id: offerId,
                offer_item_id: offerItemId,
                booking_date: date,
                notes: notes,
                type: type
            }),
        });
        const data = await response.json();
        if (data.success) {
            if (data.data?.payment_url) {
                // SkipCash is configured — redirect to payment page
                if (typeof window !== "undefined") {
                    window.location.href = data.data.payment_url;
                }
                return { success: true, payment_url: data.data.payment_url, booking_id: data.data.booking_id };
            } else {
                // SkipCash not configured yet — booking created as pending
                MyNotifications({
                    text: language === "ar"
                        ? "تم إنشاء الحجز بنجاح! بوابة الدفع قيد الإعداد."
                        : "Booking created successfully! Payment gateway is being set up.",
                    color: "green",
                    icon: <IconCheck />,
                });
                return { success: true, booking_id: data.data.booking_id, amount: data.data.amount };
            }
        } else {
            const msg = data.data?.message || data.data;
            MyNotifications({
                text: language === "ar"
                    ? "خطأ: " + (typeof msg === 'string' ? msg : "غير قادر على بدء الدفع")
                    : "Error: " + (typeof msg === 'string' ? msg : "Unable to initiate payment"),
                color: "red",
                icon: <IconAlertTriangle />,
            });
            return { success: false };
        }
    } catch (err) {
        console.error(err);
        MyNotifications({
            text: language === "ar" ? "لقد حدث خطأ ما." : "Something went wrong.",
            color: "red",
            icon: <IconAlertTriangle />,
        });
        return { success: false };
    }
};
export interface ReviewCardProps {userName: string; rating: number; text: string; date: string; helpfulCount: number; review_id: number}
type AddReviewProps = { category: "Ladies" | "Gents" | "Kids" | "Pets" | "none", salonId:number, userId:number, onReviewChange:()=>void };
export const AddReview = forwardRef<HTMLDivElement, AddReviewProps>(({ category, salonId, userId, onReviewChange }, ref) => {
    const { lang } = useLanguageNavigator(availableLanguages)
    const [comment, setComment] = useState("");
    const [rating, setRating] = useState(5);
    const [selectedCompliments, setSelectedCompliments] = useState<string[]>([]);
    const storedAuth = typeof window !== "undefined" ? localStorage.getItem('salonCategory') : 'none';
    if (category == 'none' && storedAuth != null && storedAuth != undefined) {
        category = storedAuth as "Ladies" | "Gents" | "Kids" | "Pets";
    }
    const t = lang === "ar"
    ?   {
            emptyComment: "من فضلك اكتب تعليقًا قبل الإرسال.",
            success: "تم إرسال تقييمك بنجاح.",
            failed: "فشل في إرسال التقييم.",
            networkError: "حدث خطأ في الشبكة أثناء الإرسال.",
        }
    :   {
            emptyComment: "Please write a comment before submitting.",
            success: "Your review was submitted successfully.",
            failed: "Failed to submit review.",
            networkError: "Network error while sending review.",
        };
    const complimentsByCategory = lang === "ar"
    ?   {
            Ladies: ["خدمة رائعة", "طاقم لطيف", "قَصّة مثالية", "أجواء مريحة"],
            Gents: ["قَصّة ممتازة", "احترافية عالية", "سريع ونظيف", "تجربة رائعة"],
            Kids: ["ودود جدًا", "أطفالي أحبوه", "بيئة مرحة", "صبور جدًا"],
            Pets: ["عناية فائقة", "لطيف جدًا", "نظيف وآمن", "حيواني سعيد"],
            none: ["", "", "", ""],
        }
    :   {
            Ladies: ["Amazing Service", "Lovely Staff", "Perfect Haircut", "Relaxing Atmosphere"],
            Gents: ["Great Cut", "Professional", "Quick & Clean", "Excellent Experience"],
            Kids: ["Very Friendly", "My Kid Loved It", "Fun Environment", "So Patient"],
            Pets: ["Handled with Care", "Very Gentle", "Clean & Safe", "My Pet is Happy"],
            none: ["", "", "", ""],
        }

    const handleComplimentClick = (text: string) => {
        setComment((prev) => (prev ? prev + " " + text : text));
        setSelectedCompliments([...selectedCompliments, text]);
    };
    const handleSend = async () => {
        // if (!comment.trim()) { console.log("Mina"); MyNotifications({ text: t.emptyComment, color: "red", icon: <IconAlertCircle />, }); return; }
        try {
            // const body = {rating:rating, comment:comment, salon_id: salonId, user_id: userId}
            // console.log(body)
            const res = await fetch(baseApi + '/web/addReview', {
                method: 'POST',headers: { 'Content-Type': 'application/json' },
                body: JSON.stringify({rating, comment, salon_id: salonId, user_id: userId}),
            });
            const data = await res.json();
            if (res.ok) {
                MyNotifications({ text: t.success, color: "green", icon: <IconCheck /> });
                setRating(5);
                setComment("");
                setSelectedCompliments([])
                onReviewChange()
            } else {
                MyNotifications({ text: data.message || t.failed, color: "red", icon: <IconAlertTriangle /> });
            }
        } catch (error) {
            MyNotifications({ text: t.networkError, color: "red", icon: <IconAlertCircle />, });
            console.error(error);
        }
    };

    const [hoveredRating, setHoveredRating] = useState<number | null>(null);
    return (
        <Paper ref={ref} shadow="xs" p="md" style={{ backgroundColor: '#ddddddff', marginBottom: '20px' }}>
            <Center mb="sm">
                <Title order={5}>⭐ Add Review</Title>
            </Center>
            <Center mb="sm">
                <Badge color="rgba(255, 255, 255, 1)" size="xl">
                    <Rating value={rating} onChange={setRating} fractions={2} onHover={(value) => setHoveredRating(value)} color="#BC9249"/>
                </Badge>
                <Text c={'blue'} ml={22} mr={22} fw={800} fz={'h4'}>{(hoveredRating !== null ? hoveredRating < 0 ? rating : hoveredRating : rating).toFixed(1).toString()}</Text>
            </Center>
            <Group align="center" gap="xs" mb="xs">
                <Textarea 
                    placeholder="Write your comment..." value={comment}
                    onChange={(e) => setComment(e.currentTarget.value)}
                    autosize minRows={2} style={{ flex: 1 }}
                />
                <ActionIcon color="green" radius="xl" size="lg" onClick={handleSend}>
                    <IconSend size={20}/>
                </ActionIcon>
            </Group>

            <Group gap="xs" align="center">
                {complimentsByCategory[category].map((text) => (
                <Badge
                    key={text}
                    onClick={() => handleComplimentClick(text)}
                    // variant={selectedCompliments.includes(text) ? "filled" : "light"}
                    variant={"filled"}
                    color={selectedCompliments.includes(text) ? "#c9a365" : "#adadadff"}
                    style={{ cursor: "pointer" }}
                >
                    {text}
                </Badge>
                ))}
            </Group>
        </Paper>
    );
})
export const ReviewCard = ({userName, rating, text, date, helpfulCount, review_id}: ReviewCardProps ) => {
    const maskedName = maskUserName(userName);
    const [disabledReviews, setDisabledReviews] = useState<boolean>(false);
    const [count, setCount] = useState<number>(helpfulCount);
    const increaseHelpful = (): (() => void) => {
        return async () => {
            setDisabledReviews(true); 
            try {
                const res = await axios.post(`${baseApi}/web/increaseHelpful`, { review_id });
                console.log(res)
                if (res.data.success) { 
                    console.log(res.data)
                    setCount(res.data.data.helpful_count) 
                }
            } catch (err) {
            console.error("Failed to increase helpful count:", err);
            } finally {
            // Optionally re-enable later if you want users to click again after some time
            // setDisabledReviews(prev => prev.filter(id => id !== review_id));
            }
        };
    };
    return (
        <Card shadow="sm" radius="md" withBorder p="md">
            <Group justify="space-between" align="flex-start">
                <Group gap="md">
                    <Text fw={600}>{maskedName}</Text>
                    <Rating readOnly value={rating} fractions={2} />
                </Group>
                <Text size="xs" c="dimmed">{formatDate(date)}</Text>
            </Group>
            <Text mt="sm" size="sm">{text}</Text>
            <Group justify="end" mt="sm">
                <Group gap={4}>
                    <Tooltip label="Mark as helpful">
                        <ActionIcon variant="subtle" onClick={increaseHelpful()} disabled={disabledReviews} style={{ opacity: disabledReviews ? 0.8 : 1 }}>
                            <IconThumbUp size={16} />
                        </ActionIcon>
                    </Tooltip>
                    <Text size="sm" c="dimmed">Helpful ({count})</Text>
                </Group>
            </Group>
        </Card>
    );
};
const maskUserName = (name: string): string => {
    if (name.length <= 2) return name;
    const first = name[0];
    const last = name[name.length - 1];
    return `${first}***${last}`;
}
const formatDate = (dateStr: string): string => {
    const date = new Date(dateStr);
    return date.toLocaleDateString("en-US", {month: "short",day: "2-digit",year: "numeric",});
};
export const BtnMariam = ({name, mb, onclick, font = 28, selected = false}:{name:string, mb:number, onclick:()=>void, font?:number, selected?:boolean}) =>{
    return(
        <Center mb={mb} onClick={onclick}>
            <div style={{ display: "flex", alignItems: "center", justifyContent: "center", width: "80px",
            height: "65px", border: selected ? "3px solid #c9a365" : "3px solid white", color: "#c9a365", borderRadius: "7px", fontSize: `${font}px`, fontWeight: "normal",
            textTransform: "uppercase", fontFamily: "BebasKai, sans-serif", position: "relative", cursor: "pointer",backgroundColor: "black",
            clipPath: "polygon(0 0, 100% 0, 100% 100%, 40% 100%, 40% 85%, 15% 85%, 15% 100%, 0% 100%)"}}>{name}</div>
        </Center>
            
    )
}    
export const Shop = ({ id, name, img, language, maxCards }: { id: number; name: string; img: string; language: string; maxCards:number}) => {
    const { width } = useViewportSize();
    const calculatedWidth = Math.min(130, (width - (maxCards * 10))/ maxCards);
    const link = language === "en" ? `/shops/${id}` : `/ar/shops/${id}`;
    return (
        <Link to={link} style={{ textDecoration: "none", margin: "5px" }}>
            <Card padding="0" radius="0" shadow="sm"
                style={{ width: calculatedWidth,backgroundColor: "black",transition: "all 0.3s ease",transform: "scale(1)",boxShadow: "0 0 0px rgba(188, 146, 73, 0)", cursor: "pointer",}}
                onMouseEnter={(e) => {
                    e.currentTarget.style.transform = "scale(1.05)";
                    e.currentTarget.style.boxShadow = "0 0 15px rgba(188, 146, 73, 0.6)";
                }}
                onMouseLeave={(e) => {
                    e.currentTarget.style.transform = "scale(1)";
                    e.currentTarget.style.boxShadow = "0 0 0px rgba(188, 146, 73, 0)";
                }}
            >
                <AspectRatio ratio={8 / 7} style={{ border: "1px solid #BC9249", }}>
                {/* cover */}
                    <Image src={img} alt={name} fit="fill" height="100%" width="100%" />
                </AspectRatio>
                <Text fz={12} mt={5} ta="center" lineClamp={1} c="white" style={{ fontFamily: "Montserrat, sans-serif" }}>
                    {name}
                </Text>
            </Card>
        </Link>
    );
};
export const Mood = ({txt}:{txt:string}) => {
    const mv = 12
    return (
        <div style={{ width: '100%', borderRadius: '15px', height: '60px', marginBottom: '17px', background: 'linear-gradient(270deg, #BC9249 0%, #EAD28C 49%)'}}>
            <Text c="black" mr={mv} fw={500} fz={'h3'} ml={mv}>{txt}</Text>
            <Text c="black" mr={mv} ml={mv}>41 PLACES</Text>
        </div>
    )
}
export const Slides = ({ img, title, text, ctaLabel, ctaLink }: SlideProps) => {
    return (
        <div style={{ position: 'relative', display: 'inline-block', width: '100%', background:'rgb(207, 207, 207)', overflow: 'hidden', }}>
            <img src={img} alt="Slide" style={{ display: 'block', width: '100%', height: '100%', objectFit: 'fill', maxHeight: '200px', minHeight:'200px' }}/>
        </div>
    );
};
// : React.FC<Salon>
export const SalonData = ({salon, location, language, onScrollClick}:{salon:Salon, location:Location, language:"en"|"ar", onScrollClick: () => void}) => {
    const isLoggedIn:boolean= useSelector(state => state.auth.isLoggedIn);
    const user:MyUser= useSelector(state => state.auth.user);
    const baseButtonProps = {style: { minWidth: "80px" }, variant: "gradient", pt:0, pb:0, c:'#FFF',  size:"compact-xs", m:0, radius:'xl', gradient:{ from: '#EAD28C', to: '#BC9249', deg: 90 }, fw:200, fz:8};
    const grayButtonProps = {style: { minWidth: "80px" }, c:"black", color:'#f0f0f0',  size:"compact-xs", m:0, radius:'xl', fw:200, fz:8};
    const [bookModal, setBookModal] = useState(false);
    const [selectedDate, setSelectedDate] = useState<string | null>(null);
    const addFavorite = async (user_id: number, salon_id: number) => {
        try {
            const res = await fetch(`${baseApi}/web/addFavorite`, { method: "POST", headers: { "Content-Type": "application/json" }, body: JSON.stringify({ user_id, salon_id }),});
            const data = await res.json();
            if (!res.ok) {
                if (data?.data === "Already added to favorites") {
                    MyNotifications({ 
                        text: language === "ar" ? "هذا الصالون مضاف بالفعل إلى مفضلتك." : "Already in your favorites.", 
                        color: "blue", 
                        icon: <IconInfoCircle />, 
                    });
                } else {
                    MyNotifications({ 
                        text: language === "ar" ? "فشل في إضافة المفضلة." : "Failed to add favorite.", 
                        color: "red", 
                        icon: <IconAlertTriangle />, 
                    });
                }
            } else {
                MyNotifications({ 
                    text: language === "ar" ? "تمت إضافة الصالون إلى مفضلتك!" : "Added to favorites successfully!", 
                    color: "green", 
                    icon: <IconCheck />, 
                });
            }
            return data;
        } catch (err) {
            MyNotifications({ 
                text: language === "ar" ? "فشل في إضافة المفضلة." : "Failed to add favorite.", 
                color: "red", 
                icon: <IconAlertTriangle />, 
            });
            return null;
        }
    }
    const increaseSalonCallCount = async (salonId: number) => {
        try {
            const response = await fetch(`${baseApi}/web/increaseCallCount/${salonId}`, {method: 'POST', headers: { 'Content-Type': 'application/json' }, });
            const data = await response.json();
            return data;
        } catch (err) {
            console.error('Error increasing call count:', err);
            return null;
        }
    };
    
    const clickAction = (e:number) =>{
        switch (e) {
            case 1: // Call
                increaseSalonCallCount(salon.id!!)
                if(typeof window !== "undefined"){
                    if (salon.phone != "" && salon.phone != null) {
                        window.location.href = `tel:${salon.phone}`;
                    }
                }
                break;
            case 2: // Book Now
                if (isLoggedIn) {
                    setBookModal(true)
                }else{
                    localStorage.setItem("redirectAfterLogin", window.location.pathname)
                    navigate("/auth/login")
                }
                break;
            case 3: // Add review
                if (isLoggedIn) {
                    onScrollClick()    
                }else{
                    localStorage.setItem("redirectAfterLogin", window.location.pathname)
                    navigate("/auth/login")
                }
                break;
            case 4: // Add Favorite
                addFavorite(user.id ?? 0, salon.id ?? 0)
                break;
            default: break;
        }
    }
    const containerRef2 = useRef<HTMLDivElement>(null);
    const splitWorkingHours = (text?: string | null): string[] => {
        if (!text) return []; ///\r?\n/
        return text.split(".").map(line => line.trim()).filter(line => line.length > 0);
    }    
    // console.log("Salon Working Hours:", salon?.working_hours, salon?.working_hours_ar);
    const workingHoursText = language === 'en' ?  salon?.working_hours ?? "" :  salon?.working_hours_ar ?? "";
    const workingHoursList = splitWorkingHours(workingHoursText);
    const address = language == 'en' ? salon?.address : salon?.address_ar
    const loc = language == 'en' ? location?.name : location?.name_ar
    const name = language == 'en' ? salon?.name : salon?.name_ar
    const t = language === "ar" ? 
    {call: "اتصال",bookNow: "احجز الآن",addReview: "أضف تقييمًا",addFavorite: "أضف إلى المفضلة",} : 
    {call: "CALL",bookNow: "BOOK NOW",addReview: "ADD REVIEW",addFavorite: "ADD FAVORITE",};
    const promotionClick = async () => {
        try {
            const res = await axios.post(`${baseApi}/web/checkPromotion`, { salon_id: salon.id });
            console.log(res)
            if (res.data.success && res.data.data) {
                navigate(`/offer/${res.data.data.id}/`); // ✅ Promotion found — navigate to it
            } else {
                MyNotifications({ // 🚫 No promotion
                    text: language === "ar" ? "لا توجد عروض حالياً." : "No promotions available right now.",
                    color: "orange", icon: <IconInfoCircle />,
                });
            }
        } catch (err) {
            console.error("Failed to check promotions:", err);
            MyNotifications({
                text: language === "ar" ? "حدث خطأ أثناء التحقق من العروض." : "Error while checking promotions.",
                color: "red", icon: <IconAlertTriangle />,
            });
        }
    };
    // Modal code
    // 1. Fetch real availability data
    // const { content: availableSlots, loading, error } = usePageContent(`/next-seven/${salon.id}`, null);
    // Only create the URL string if the modal is actually triggered
    const fetchUrl = bookModal ? `/next-seven/${salon.id}` : null;
    const { content: availableSlots, loading, error } = usePageContent(fetchUrl, null);
    const [preferredTime, setPreferredTime] = useState('');
    const [notes, setNotes] = useState('');
    const salonDisplayName = salon != undefined ? language === 'ar' ? (salon.name_ar || salon.name) : salon.name : "";

    return(
        <>
        <Card shadow="sm">
            <Group align="center" justify="space-between" preventGrowOverflow={true} wrap="nowrap">
                <Group wrap="nowrap">
                    <Image src={salon?.logo} width={80} height={80} fit="fill" alt="Photo" style={{ aspectRatio: "1 / 1", border: "1px solid #BC9249" }} />
                    <div>
                        <Text fw={300} fz={12} size="md" style={{ textTransform: "uppercase" }}>{name}</Text>
                        <Text fw={200} fz={10} size="sm" c="black">{loc}, {address}</Text>
                        <Text fw={200} fz={10} size="sm" c="black">{workingHoursList[0]}</Text>
                        <Text fw={200} fz={10} size="sm" c="black">{workingHoursList[1]}</Text>
                        <Group gap={4} align="center">
                            <IconMapPinFilled size={14} color="blue" style={{ marginTop: 2 }} />
                            <Text fw={200} fz={10} c="blue"><a href={salon?.address_link ?? ""} target="_blank">{language == 'en' ? "Location on the map" : "الموقع على الخريطة"}</a></Text>
                        </Group>
                        <Group gap={4} align="center">
                            <IconEye size={14} color="black" style={{ marginTop: 2 }} />
                            <Text fw={200} fz={10} c="black">{salon?.views_count}</Text>
                        </Group>
                    </div>
                </Group>
                <div style={{ display:'flex', flexDirection:'column', alignItems:'flex-end' }}>
                    <Text fw={150} fz={11} size="sm" c="black">{salon?.ratings_count} {language == "en" ? "review" : "مراجعة"}</Text>
                    <Rating value={salon?.rating_value} fractions={2} color={'#BC9249'} readOnly />
                    <Button 
                        variant="filled" p={0} m={0} color="#00A000" radius="xl" 
                        pl={8} pr={8} fw={200} fz={7} size={'compact-xs'} onClick={promotionClick}
                    >
                        {language == "en" ? "CHECK PROMOTION" : "الترويج"}
                    </Button>
                </div>
            </Group>
            <Center mt="md"><div ref={containerRef2} style={{display: "flex", overflowX: "auto", whiteSpace: "nowrap", gap: "8px", cursor: "grab", userSelect: "all", scrollbarWidth: "none",WebkitOverflowScrolling: "touch", paddingRight:"10px", paddingLeft:"10px"}}>
                <Button {...baseButtonProps} onClick={() => clickAction(1)} leftSection={<IconPhoneFilled size={10}/>}>{t.call}</Button>
                <Button {...grayButtonProps} onClick={() => clickAction(2)} leftSection={<IconBuildingStore size={10}/>}>{t.bookNow}</Button>
                <Button {...grayButtonProps} onClick={() => clickAction(3)} leftSection={<IconStarFilled size={10}/>}>{t.addReview}</Button>
                <Button {...grayButtonProps} onClick={() => clickAction(4)} leftSection={<IconHeartFilled size={10}/>}>{t.addFavorite}</Button>
            </div></Center>
        </Card>
        <Modal 
            onClose={() => setBookModal(false)} 
            opened={bookModal} 
            title={<Text fw={700} size="lg">{salonDisplayName}</Text>} 
            centered
            size="md"
        >
            <Stack gap="md">
                {/* 5. Clear Payment Policy */}
                <Alert variant="light" color="blue" title="Booking Policy" icon={<IconInfoCircle />}>
                    {language === 'ar' 
                        ? 'رسوم الحجز 10 ر.ق غير قابلة للاسترداد' 
                        : 'Booking fees are 10 QAR (Non-refundable)'}
                </Alert>

                {/* 3a. Loading State */}
                {loading && (
                    <Group justify="center" py="xl">
                        <Loader size="sm" />
                        <Text size="sm">Checking availability...</Text>
                    </Group>
                )}

                {/* 3c. No Data Available State */}
                {!loading && (!availableSlots || availableSlots.length === 0) && (
                    <Stack align="center" py="xl">
                        <Text c="dimmed" ta="center">
                            {language === 'ar' 
                                ? 'نعتذر، لا توجد مواعيد متاحة حالياً. يرجى التحقق مرة أخرى لاحقاً.' 
                                : 'We apologize, there are no available slots at the moment. Please check back later.'}
                        </Text>
                        <Button variant="subtle" onClick={() => setBookModal(false)}>Close</Button>
                    </Stack>
                )}

                {/* 3b. Data Available State */}
                {!loading && availableSlots && availableSlots.length > 0 && (
                    <>
                        <Text size="sm" fw={500}>{language === 'ar' ? 'اختر تاريخ الحجز:' : 'Select a Booking Day:'}</Text>
                        <SimpleGrid cols={2} spacing="xs">
                            {availableSlots.map((slot: any) => {
                                // Formatting date from "2026-05-13" to a local string if needed
                                const dateLabel = new Date(slot.available_date).toLocaleDateString(language === 'ar' ? 'ar-QA' : 'en-GB', {
                                    weekday: 'short',
                                    month: 'short',
                                    day: 'numeric'
                                });

                                return (
                                    <Button
                                        key={slot.id}
                                        variant={selectedDate === slot.available_date ? "filled" : "outline"}
                                        onClick={() => setSelectedDate(slot.available_date)}
                                        size="sm"
                                    >
                                        {dateLabel}
                                    </Button>
                                );
                            })}
                        </SimpleGrid>

                        {/* 4. Required Inputs - Only show if a date is selected */}
                        {selectedDate && (
                            <Stack gap="sm" mt="sm">
                                <Divider label={language === 'ar' ? 'تفاصيل إضافية' : 'Additional Details'} labelPosition="center" />
                                <TextInput 
                                    label={language === 'ar' ? 'الوقت المفضل' : 'Preferred Time'} 
                                    placeholder="e.g. 5:00 PM"
                                    value={preferredTime}
                                    onChange={(e) => setPreferredTime(e.currentTarget.value)}
                                    required
                                />
                                <Textarea 
                                    label={language === 'ar' ? 'الخدمات المطلوبة والملاحظات' : 'Required Services and Notes'} 
                                    placeholder={language === 'ar' ? 'اكتب ملاحظاتك هنا...' : 'Write your notes here...'}
                                    value={notes}
                                    onChange={(e) => setNotes(e.currentTarget.value)}
                                    rows={3}
                                />
                            </Stack>
                        )}

                        <Group mt="xl" justify="space-between">
                            <Button variant="default" onClick={() => setBookModal(false)}>
                                {language === 'ar' ? 'إلغاء' : 'Cancel'}
                            </Button>
                            <Button 
                                disabled={!selectedDate || !preferredTime}
                                onClick={() => {
                                    if (selectedDate) {
                                        // Combine notes with preferred time for the backend
                                        const fullNotes = `Time: ${preferredTime} \r\nNotes: ${notes}`;
                                        const dt = new Date(selectedDate).toLocaleDateString('en-CA')
                                        bookNow(dt, salon, user.id!!, language, fullNotes, "bk");
                                        setBookModal(false);
                                        setPreferredTime("")
                                        setNotes("")
                                    }
                                }}
                            >
                                {language === 'ar' ? 'تأكيد الحجز' : 'Confirm Booking'}
                            </Button>
                        </Group>
                    </>
                )}
            </Stack>
        </Modal>
        {/* <Modal onClose={() => setBookModal(false)} opened={bookModal} title="Select a Booking Day" centered>
            <SimpleGrid cols={1} verticalSpacing="sm">
                {getUpcomingDays().map((day) => (
                <Button
                    key={day.value}
                    variant={selectedDate === day.value ? "filled" : "outline"}
                    onClick={() => setSelectedDate(day.value)}
                >
                    {day.label} ({day.value})
                </Button>
                ))}
            </SimpleGrid>
            <Group mt="md" justify="space-between">
                <Button variant="default" onClick={() => setBookModal(false)}>Cancel</Button>
                <Button disabled={!selectedDate}
                    onClick={() => {
                        if (selectedDate) {
                            bookNow(selectedDate, salon, user.id!!, language);
                            setBookModal(false);
                        }
                    }}
                >
                Confirm
                </Button>
            </Group>
        </Modal> */}

        </>
    )
}